module.exports = __webpack_public_path__ + "img/inktober_2020_05_blade.c3c7bec9.jpg";